import styled from "styled-components";

export const NotificationDot = styled.div`
  width: 11px;
  height: 11px;
  background: #C90000;
  border-radius: 18px;
`;